module.exports = __webpack_public_path__ + "img/37967a5.svg";